<!-- Tagging for git -->

<form [formGroup]="createCourseForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="container d-flex justify-content-center">
    <div class="custom-bg-1 my-5">
        <div class="d-flex justify-content-end">
            <button  type="button" (click)="reload()"
                  class="v4-btn-every py-2"><i class="fa-solid fa-arrow-left mx-2"></i>{{"Back" |translator}}</button>
        </div>
    <div class="card-scroll">
        <div class="row">

            <div class="col-lg-12">
                <span class="label-ui"><i class="pi pi-calendar result-icons"></i>{{"the date"| translator}}&nbsp;:&nbsp;</span>
                <span>{{request.topic }} &nbsp;&nbsp; - &nbsp;&nbsp;<span [innerHTML]="request?.description | safeHTML"></span></span>
                <p-calendar class="pp-calander" formControlName="timeline" [selectionMode]="dateType" [readonlyInput]="true"  (onSelect)="dateValidate($event)">
                    <ng-template pTemplate="date" let-date>
                        <span
                            [ngStyle]="{textDecoration: disbleDates(date) ? 'line-through' : 'inherit'}">{{date.day}}</span>
                    </ng-template>
                </p-calendar>
                <div [style.color]="'red'" *ngIf="invalidDate">
                    {{invalidDate}}
                </div>
            </div>

            <div class="card-scroll" formArrayName="sessionForm">
                <div class="row" *ngFor="let session of trainingDetails?.session; let rowIndex = index;">
                    <div class="col-lg-12">
                        <div class=" online-ui">
                        <h4 class="font-bold mb-0">
                            <span class="start-your-project">
                                <span *ngIf="session?.type == 'SURVEY'" class="chit-txt"><i class="fa-solid fa-square-poll-horizontal ml-2 mr-2 chit-icon"></i></span>
                                <span *ngIf="session?.type == 'ASSESSMENT'" class="chit-txt"><i class="fa-solid fa-pen-nib ml-2 mr-2 chit-icon"></i></span>
                                <span *ngIf="session?.type == 'SESSION'" class="chit-txt"><i class="fa fa-chalkboard-user ml-2 mr-2 chit-icon"></i></span>
                            </span>
                            {{session?.title}}</h4>
                            <!-- : {{rowIndex}} -->
                    </div>
                </div>
                <!--  -->
                    <div class="col-lg-12">
                        <div>
                            <span class="label-ui"><i class="pi pi-calendar result-icons"></i>{{"the date"| translator}}&nbsp;:&nbsp;</span>

                            <p-calendar class="pp-calander"  (onSelect)="updateFormDateCheck($event,rowIndex)" [formControl]="$any(sessionFormArray[rowIndex].get('date'))">
                        
                            </p-calendar>

                            <span [style.color]="'red'" *ngIf="errorMessage && sessionFormArray[rowIndex].get('date')?.status =='INVALID'">
                                {{errorMessage}}</span>
                        </div>
                    </div>

                    <div class="col-lg-6" *ngIf="session?.type != 'SURVEY'">
                        <label class="label-ui mb-2" for="start_time">
                            {{"Starting time" | translator}}
                        </label>
                        <input class="pp-input" type="time" id="start_time" placeholder='{{"Please enter start time"| translator}}' (change)="startTimeChange(rowIndex)" [formControl]="$any(sessionFormArray[rowIndex].get('start_time'))" pInputText class="w-full mb-3">
                    </div>

                    <div class="col-lg-6" *ngIf="session?.type != 'SURVEY'">
                        <label class="label-ui mb-2" for="end time">
                            {{"end time" | translator}}
                        </label>
                        <input class="pp-input" type="time" id="end_time" placeholder='{{"Please enter end time"| translator}}' (change)="endTimeChange(rowIndex)" [formControl]="$any(sessionFormArray[rowIndex].get('end_time'))" pInputText class="w-full mb-3">

                        <span [style.color]="'red'" *ngIf="errorMessageTime && sessionFormArray[rowIndex].get('end_time')?.status =='INVALID'">
                            {{errorMessageTime}}</span>
                    </div>

                    <div class="col-lg-12" *ngIf="session?.type == 'SESSION' && session?.typeId?.zoom_url">
                        <label class="label-ui mb-2" >
                         add url
                        </label>
                        <input class="pp-input" type="text"  placeholder='add url' [formControl]="$any(sessionFormArray[rowIndex].get('url'))" pInputText class="w-full mb-3">
                    </div>


                </div>
            </div>
            <div class="card" *ngIf="spinner" >
                <p-progressSpinner></p-progressSpinner>
            </div>
            <!-- Add Session Form end -->
            <div class="col-12">
                <div class="my-3">
                <button type="submit" [disabled]="!createCourseForm.valid" class="w-100 v4-btn-every py-2"><i class="pi pi-pencil v4-ml-2"></i>{{ "OK" | translator}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
</form>

<div class="container my-5">
    <div class="d-flex justify-content-between my-3 align-items-center">
        <h5 class="bold-600">{{'Pending Attendees' | translator}}</h5>
        
    </div>   
    <p-table [hidden]="pendingUsers?.length <= 0 " styleClass="custom-table" [value]="pendingUsers" dataKey="code"
            [paginator]="true" [scrollable]="true" [rows]="10" [selectionPageOnly]="true"
            [tableStyle]="{'min-width': '40rem'}">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{"name"| translator}} </th>
                    <th>{{"Email"| translator}}</th>
                    <th>{{"Gender"| translator}}</th>
                    <th>{{"National ID"| translator}}</th>
                    <th>{{"Phone Number"| translator}}</th>
                    <!-- <th style="min-width:200px">{{"Action"| translator}}</th> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-trainer>
                <tr>
                    <td>{{trainer.name.first}} {{trainer.name.middle}}  {{trainer.name.last}}</td>
                    <td>{{trainer.email}}</td>
                    <td>{{trainer?.gender}}</td>
                    <td>{{trainer?.national_id}}</td>
                    <td>{{trainer?.phone}}</td>
    
                </tr>
            </ng-template>
        </p-table>
</div>


<!-- <app-footer></app-footer> -->

